import { render, staticRenderFns } from "./my-integral-record.vue?vue&type=template&id=65efc9a4&"
import script from "./my-integral-record.vue?vue&type=script&lang=js&"
export * from "./my-integral-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports